import React, { useEffect, useState } from 'react';
import './WarningForNurture.css';
import { getAccountwiseCampaignList } from '../../../../../services/iqApiV2';
import { useUser } from '../../../../../context/UserContext';

function WarningForNurture({ clientName, accountName, oppId, contactId,setIsContinueDisabled=()=>{},generalWarning=false, generalWarningTxt="" }) {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useUser();

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await getAccountwiseCampaignList(
          clientName,
          accountName,
          oppId,
          contactId
        );

        const relevant = response?.data?.filter(
          (item) => item.opportunity_id === oppId
        );

        setCampaigns(relevant || []);
        if(relevant?.length>0) {setIsContinueDisabled(true)}else{setIsContinueDisabled(false)}
      } catch (error) {
        console.error('WarningForNurture error:', error);
        setCampaigns([]);
      } finally {
        setLoading(false);
      }
    };

    if (clientName && accountName && (oppId || contactId)) {
      fetchCampaigns();
    }
  }, [clientName, accountName, oppId, contactId]);

  const users = [
    ...new Set(
      campaigns.map((c) =>
        c.user_id === user?.id ? 'You' : c.user_name
      )
    ),
  ];

  if (generalWarning && generalWarningTxt) {
    return  <div className="warning-nurture-banner">
      <div className="warning-content">
        <span className="warning-text">
        {generalWarningTxt}
        </span>
      </div>
    </div>
  }



  if (loading || campaigns.length === 0) return null;

  return (
    <div className="warning-nurture-banner">
      <div className="warning-content">
        <span className="warning-text">
          This Opportunity is already being nurtured by {users.join(', ')}.
        </span>
      </div>
    </div>
  );
}

export default WarningForNurture;
